import { IconName } from '@/config/icons'

export const NAV_TOPNAV: {
  label: string
  title: string
  href: string
  icon: IconName
}[] = [
  {
    label: 'Franchise Applications',
    title: 'Apply for a franchise',
    href: '/franchise-application',
    icon: 'apply'
  }
]
